import { createLoadingSelector } from '../../../../redux/selectors/loader';

export const mapStateToProps = state => {
    const loadingSelector = createLoadingSelector(['GET_ORDER']);
    return {
        order: state.order.order,
        loading: loadingSelector(state),
    };
};
